"use strict";

exports.__esModule = true;
exports.PlusSquare = exports.PlusCircle = exports.Photo = exports.PhotoOff = exports.Phone = exports.Percent = exports.Package = exports.MoreVertical = exports.MoreHorizontal = exports.Money = exports.MoneySmall = exports.Minus = exports.MinusSquare = exports.MinusCircle = exports.Minimize = exports.Minimize2 = exports.MessageSquare = exports.MessageCircle = exports.Menu = exports.Maximize = exports.Maximize2 = exports.Map = exports.MapPin = exports.Mail = exports.LogOut = exports.LogIn = exports.Lock = exports.Loader = exports.List = exports.Link = exports.Link2 = exports.Info = exports.Inbox = exports.Image = exports.Home = exports.HelpCircle = exports.Heart = exports.HeartFilled = exports.Headset = exports.Headphones = exports.Hash = exports.Grid = exports.Folder = exports.Flag = exports.Filter = exports.File = exports.FileText = exports.FilePlus = exports.FileMinus = exports.Eye = exports.EyeOff = exports.ExternalLink = exports.Edit = exports.Edit3 = exports.Edit2 = exports.Download = exports.DownloadCloud = exports.Delivery = exports.CreditCard = exports.Copy = exports.Compass = exports.Clock = exports.Clipboard = exports.ChevronsUp = exports.ChevronsRight = exports.ChevronsLeft = exports.ChevronsDown = exports.ChevronUp = exports.ChevronRight = exports.ChevronLeft = exports.ChevronDown = exports.Check = exports.CheckSquare = exports.CheckCircle = exports.Check2Small = exports.Check1Small = exports.Camera = exports.CameraOff = exports.Calendar = exports.Briefcase = exports.Box = exports.Bookmark = exports.Bell = exports.BellOff = exports.Barcode = exports.BarChart = exports.BarChart2 = exports.Award = exports.AtSign = exports.ArrowUp = exports.ArrowUpRight = exports.ArrowUpLeft = exports.ArrowRight = exports.ArrowLeft = exports.ArrowDown = exports.ArrowDownRight = exports.ArrowDownLeft = exports.AlertTriangle = exports.AlertCircle = exports.Activity = void 0;
exports.Monitor = exports.ZoomOut = exports.ZoomIn = exports.Zap = exports.X = exports.XSquare = exports.XCircle = exports.Wallet = exports.Volume = exports.VolumeX = exports.Volume2 = exports.Volume1 = exports.Users = exports.User = exports.Upload = exports.UploadCloud = exports.Unlock = exports.TrustShield = exports.Truck = exports.TrendingUp = exports.TrendingDown = exports.Trash = exports.Trash2 = exports.ThumbsUp = exports.ThumbsDown = exports.Tag = exports.Star = exports.Speaker = exports.Smartphone = exports.Sliders = exports.Slash = exports.ShoppingCart = exports.ShoppingBag = exports.Shop = exports.Shield = exports.Share = exports.Share2 = exports.Settings = exports.Sent2 = exports.Search = exports.Save = exports.SafeBuy = exports.RotateCw = exports.RotateCcw = exports.Rocket = exports.Repeat = exports.RefreshCw = exports.RefreshCcw = exports.QrCode = exports.Printer = exports.Pocket = exports.Plus = void 0;

var _Activity = _interopRequireDefault(require("./Activity"));

exports.Activity = _Activity["default"];

var _AlertCircle = _interopRequireDefault(require("./AlertCircle"));

exports.AlertCircle = _AlertCircle["default"];

var _AlertTriangle = _interopRequireDefault(require("./AlertTriangle"));

exports.AlertTriangle = _AlertTriangle["default"];

var _ArrowDownLeft = _interopRequireDefault(require("./ArrowDownLeft"));

exports.ArrowDownLeft = _ArrowDownLeft["default"];

var _ArrowDownRight = _interopRequireDefault(require("./ArrowDownRight"));

exports.ArrowDownRight = _ArrowDownRight["default"];

var _ArrowDown = _interopRequireDefault(require("./ArrowDown"));

exports.ArrowDown = _ArrowDown["default"];

var _ArrowLeft = _interopRequireDefault(require("./ArrowLeft"));

exports.ArrowLeft = _ArrowLeft["default"];

var _ArrowRight = _interopRequireDefault(require("./ArrowRight"));

exports.ArrowRight = _ArrowRight["default"];

var _ArrowUpLeft = _interopRequireDefault(require("./ArrowUpLeft"));

exports.ArrowUpLeft = _ArrowUpLeft["default"];

var _ArrowUpRight = _interopRequireDefault(require("./ArrowUpRight"));

exports.ArrowUpRight = _ArrowUpRight["default"];

var _ArrowUp = _interopRequireDefault(require("./ArrowUp"));

exports.ArrowUp = _ArrowUp["default"];

var _AtSign = _interopRequireDefault(require("./AtSign"));

exports.AtSign = _AtSign["default"];

var _Award = _interopRequireDefault(require("./Award"));

exports.Award = _Award["default"];

var _BarChart = _interopRequireDefault(require("./BarChart2"));

exports.BarChart2 = _BarChart["default"];

var _BarChart2 = _interopRequireDefault(require("./BarChart"));

exports.BarChart = _BarChart2["default"];

var _Barcode = _interopRequireDefault(require("./Barcode"));

exports.Barcode = _Barcode["default"];

var _BellOff = _interopRequireDefault(require("./BellOff"));

exports.BellOff = _BellOff["default"];

var _Bell = _interopRequireDefault(require("./Bell"));

exports.Bell = _Bell["default"];

var _Bookmark = _interopRequireDefault(require("./Bookmark"));

exports.Bookmark = _Bookmark["default"];

var _Box = _interopRequireDefault(require("./Box"));

exports.Box = _Box["default"];

var _Briefcase = _interopRequireDefault(require("./Briefcase"));

exports.Briefcase = _Briefcase["default"];

var _Calendar = _interopRequireDefault(require("./Calendar"));

exports.Calendar = _Calendar["default"];

var _CameraOff = _interopRequireDefault(require("./CameraOff"));

exports.CameraOff = _CameraOff["default"];

var _Camera = _interopRequireDefault(require("./Camera"));

exports.Camera = _Camera["default"];

var _Check1Small = _interopRequireDefault(require("./Check1Small"));

exports.Check1Small = _Check1Small["default"];

var _Check2Small = _interopRequireDefault(require("./Check2Small"));

exports.Check2Small = _Check2Small["default"];

var _CheckCircle = _interopRequireDefault(require("./CheckCircle"));

exports.CheckCircle = _CheckCircle["default"];

var _CheckSquare = _interopRequireDefault(require("./CheckSquare"));

exports.CheckSquare = _CheckSquare["default"];

var _Check = _interopRequireDefault(require("./Check"));

exports.Check = _Check["default"];

var _ChevronDown = _interopRequireDefault(require("./ChevronDown"));

exports.ChevronDown = _ChevronDown["default"];

var _ChevronLeft = _interopRequireDefault(require("./ChevronLeft"));

exports.ChevronLeft = _ChevronLeft["default"];

var _ChevronRight = _interopRequireDefault(require("./ChevronRight"));

exports.ChevronRight = _ChevronRight["default"];

var _ChevronUp = _interopRequireDefault(require("./ChevronUp"));

exports.ChevronUp = _ChevronUp["default"];

var _ChevronsDown = _interopRequireDefault(require("./ChevronsDown"));

exports.ChevronsDown = _ChevronsDown["default"];

var _ChevronsLeft = _interopRequireDefault(require("./ChevronsLeft"));

exports.ChevronsLeft = _ChevronsLeft["default"];

var _ChevronsRight = _interopRequireDefault(require("./ChevronsRight"));

exports.ChevronsRight = _ChevronsRight["default"];

var _ChevronsUp = _interopRequireDefault(require("./ChevronsUp"));

exports.ChevronsUp = _ChevronsUp["default"];

var _Clipboard = _interopRequireDefault(require("./Clipboard"));

exports.Clipboard = _Clipboard["default"];

var _Clock = _interopRequireDefault(require("./Clock"));

exports.Clock = _Clock["default"];

var _Compass = _interopRequireDefault(require("./Compass"));

exports.Compass = _Compass["default"];

var _Copy = _interopRequireDefault(require("./Copy"));

exports.Copy = _Copy["default"];

var _CreditCard = _interopRequireDefault(require("./CreditCard"));

exports.CreditCard = _CreditCard["default"];

var _Delivery = _interopRequireDefault(require("./Delivery"));

exports.Delivery = _Delivery["default"];

var _DownloadCloud = _interopRequireDefault(require("./DownloadCloud"));

exports.DownloadCloud = _DownloadCloud["default"];

var _Download = _interopRequireDefault(require("./Download"));

exports.Download = _Download["default"];

var _Edit = _interopRequireDefault(require("./Edit2"));

exports.Edit2 = _Edit["default"];

var _Edit2 = _interopRequireDefault(require("./Edit3"));

exports.Edit3 = _Edit2["default"];

var _Edit3 = _interopRequireDefault(require("./Edit"));

exports.Edit = _Edit3["default"];

var _ExternalLink = _interopRequireDefault(require("./ExternalLink"));

exports.ExternalLink = _ExternalLink["default"];

var _EyeOff = _interopRequireDefault(require("./EyeOff"));

exports.EyeOff = _EyeOff["default"];

var _Eye = _interopRequireDefault(require("./Eye"));

exports.Eye = _Eye["default"];

var _FileMinus = _interopRequireDefault(require("./FileMinus"));

exports.FileMinus = _FileMinus["default"];

var _FilePlus = _interopRequireDefault(require("./FilePlus"));

exports.FilePlus = _FilePlus["default"];

var _FileText = _interopRequireDefault(require("./FileText"));

exports.FileText = _FileText["default"];

var _File = _interopRequireDefault(require("./File"));

exports.File = _File["default"];

var _Filter = _interopRequireDefault(require("./Filter"));

exports.Filter = _Filter["default"];

var _Flag = _interopRequireDefault(require("./Flag"));

exports.Flag = _Flag["default"];

var _Folder = _interopRequireDefault(require("./Folder"));

exports.Folder = _Folder["default"];

var _Grid = _interopRequireDefault(require("./Grid"));

exports.Grid = _Grid["default"];

var _Hash = _interopRequireDefault(require("./Hash"));

exports.Hash = _Hash["default"];

var _Headphones = _interopRequireDefault(require("./Headphones"));

exports.Headphones = _Headphones["default"];

var _Headset = _interopRequireDefault(require("./Headset"));

exports.Headset = _Headset["default"];

var _HeartFilled = _interopRequireDefault(require("./HeartFilled"));

exports.HeartFilled = _HeartFilled["default"];

var _Heart = _interopRequireDefault(require("./Heart"));

exports.Heart = _Heart["default"];

var _HelpCircle = _interopRequireDefault(require("./HelpCircle"));

exports.HelpCircle = _HelpCircle["default"];

var _Home = _interopRequireDefault(require("./Home"));

exports.Home = _Home["default"];

var _Image = _interopRequireDefault(require("./Image"));

exports.Image = _Image["default"];

var _Inbox = _interopRequireDefault(require("./Inbox"));

exports.Inbox = _Inbox["default"];

var _Info = _interopRequireDefault(require("./Info"));

exports.Info = _Info["default"];

var _Link = _interopRequireDefault(require("./Link2"));

exports.Link2 = _Link["default"];

var _Link2 = _interopRequireDefault(require("./Link"));

exports.Link = _Link2["default"];

var _List = _interopRequireDefault(require("./List"));

exports.List = _List["default"];

var _Loader = _interopRequireDefault(require("./Loader"));

exports.Loader = _Loader["default"];

var _Lock = _interopRequireDefault(require("./Lock"));

exports.Lock = _Lock["default"];

var _LogIn = _interopRequireDefault(require("./LogIn"));

exports.LogIn = _LogIn["default"];

var _LogOut = _interopRequireDefault(require("./LogOut"));

exports.LogOut = _LogOut["default"];

var _Mail = _interopRequireDefault(require("./Mail"));

exports.Mail = _Mail["default"];

var _MapPin = _interopRequireDefault(require("./MapPin"));

exports.MapPin = _MapPin["default"];

var _Map = _interopRequireDefault(require("./Map"));

exports.Map = _Map["default"];

var _Maximize = _interopRequireDefault(require("./Maximize2"));

exports.Maximize2 = _Maximize["default"];

var _Maximize2 = _interopRequireDefault(require("./Maximize"));

exports.Maximize = _Maximize2["default"];

var _Menu = _interopRequireDefault(require("./Menu"));

exports.Menu = _Menu["default"];

var _MessageCircle = _interopRequireDefault(require("./MessageCircle"));

exports.MessageCircle = _MessageCircle["default"];

var _MessageSquare = _interopRequireDefault(require("./MessageSquare"));

exports.MessageSquare = _MessageSquare["default"];

var _Minimize = _interopRequireDefault(require("./Minimize2"));

exports.Minimize2 = _Minimize["default"];

var _Minimize2 = _interopRequireDefault(require("./Minimize"));

exports.Minimize = _Minimize2["default"];

var _MinusCircle = _interopRequireDefault(require("./MinusCircle"));

exports.MinusCircle = _MinusCircle["default"];

var _MinusSquare = _interopRequireDefault(require("./MinusSquare"));

exports.MinusSquare = _MinusSquare["default"];

var _Minus = _interopRequireDefault(require("./Minus"));

exports.Minus = _Minus["default"];

var _MoneySmall = _interopRequireDefault(require("./MoneySmall"));

exports.MoneySmall = _MoneySmall["default"];

var _Money = _interopRequireDefault(require("./Money"));

exports.Money = _Money["default"];

var _MoreHorizontal = _interopRequireDefault(require("./MoreHorizontal"));

exports.MoreHorizontal = _MoreHorizontal["default"];

var _MoreVertical = _interopRequireDefault(require("./MoreVertical"));

exports.MoreVertical = _MoreVertical["default"];

var _Package = _interopRequireDefault(require("./Package"));

exports.Package = _Package["default"];

var _Percent = _interopRequireDefault(require("./Percent"));

exports.Percent = _Percent["default"];

var _Phone = _interopRequireDefault(require("./Phone"));

exports.Phone = _Phone["default"];

var _PhotoOff = _interopRequireDefault(require("./PhotoOff"));

exports.PhotoOff = _PhotoOff["default"];

var _Photo = _interopRequireDefault(require("./Photo"));

exports.Photo = _Photo["default"];

var _PlusCircle = _interopRequireDefault(require("./PlusCircle"));

exports.PlusCircle = _PlusCircle["default"];

var _PlusSquare = _interopRequireDefault(require("./PlusSquare"));

exports.PlusSquare = _PlusSquare["default"];

var _Plus = _interopRequireDefault(require("./Plus"));

exports.Plus = _Plus["default"];

var _Pocket = _interopRequireDefault(require("./Pocket"));

exports.Pocket = _Pocket["default"];

var _Printer = _interopRequireDefault(require("./Printer"));

exports.Printer = _Printer["default"];

var _QrCode = _interopRequireDefault(require("./QrCode"));

exports.QrCode = _QrCode["default"];

var _RefreshCcw = _interopRequireDefault(require("./RefreshCcw"));

exports.RefreshCcw = _RefreshCcw["default"];

var _RefreshCw = _interopRequireDefault(require("./RefreshCw"));

exports.RefreshCw = _RefreshCw["default"];

var _Repeat = _interopRequireDefault(require("./Repeat"));

exports.Repeat = _Repeat["default"];

var _Rocket = _interopRequireDefault(require("./Rocket"));

exports.Rocket = _Rocket["default"];

var _RotateCcw = _interopRequireDefault(require("./RotateCcw"));

exports.RotateCcw = _RotateCcw["default"];

var _RotateCw = _interopRequireDefault(require("./RotateCw"));

exports.RotateCw = _RotateCw["default"];

var _SafeBuy = _interopRequireDefault(require("./SafeBuy"));

exports.SafeBuy = _SafeBuy["default"];

var _Save = _interopRequireDefault(require("./Save"));

exports.Save = _Save["default"];

var _Search = _interopRequireDefault(require("./Search"));

exports.Search = _Search["default"];

var _Sent = _interopRequireDefault(require("./Sent2"));

exports.Sent2 = _Sent["default"];

var _Settings = _interopRequireDefault(require("./Settings"));

exports.Settings = _Settings["default"];

var _Share = _interopRequireDefault(require("./Share2"));

exports.Share2 = _Share["default"];

var _Share2 = _interopRequireDefault(require("./Share"));

exports.Share = _Share2["default"];

var _Shield = _interopRequireDefault(require("./Shield"));

exports.Shield = _Shield["default"];

var _Shop = _interopRequireDefault(require("./Shop"));

exports.Shop = _Shop["default"];

var _ShoppingBag = _interopRequireDefault(require("./ShoppingBag"));

exports.ShoppingBag = _ShoppingBag["default"];

var _ShoppingCart = _interopRequireDefault(require("./ShoppingCart"));

exports.ShoppingCart = _ShoppingCart["default"];

var _Slash = _interopRequireDefault(require("./Slash"));

exports.Slash = _Slash["default"];

var _Sliders = _interopRequireDefault(require("./Sliders"));

exports.Sliders = _Sliders["default"];

var _Smartphone = _interopRequireDefault(require("./Smartphone"));

exports.Smartphone = _Smartphone["default"];

var _Speaker = _interopRequireDefault(require("./Speaker"));

exports.Speaker = _Speaker["default"];

var _Star = _interopRequireDefault(require("./Star"));

exports.Star = _Star["default"];

var _Tag = _interopRequireDefault(require("./Tag"));

exports.Tag = _Tag["default"];

var _ThumbsDown = _interopRequireDefault(require("./ThumbsDown"));

exports.ThumbsDown = _ThumbsDown["default"];

var _ThumbsUp = _interopRequireDefault(require("./ThumbsUp"));

exports.ThumbsUp = _ThumbsUp["default"];

var _Trash = _interopRequireDefault(require("./Trash2"));

exports.Trash2 = _Trash["default"];

var _Trash2 = _interopRequireDefault(require("./Trash"));

exports.Trash = _Trash2["default"];

var _TrendingDown = _interopRequireDefault(require("./TrendingDown"));

exports.TrendingDown = _TrendingDown["default"];

var _TrendingUp = _interopRequireDefault(require("./TrendingUp"));

exports.TrendingUp = _TrendingUp["default"];

var _Truck = _interopRequireDefault(require("./Truck"));

exports.Truck = _Truck["default"];

var _TrustShield = _interopRequireDefault(require("./TrustShield"));

exports.TrustShield = _TrustShield["default"];

var _Unlock = _interopRequireDefault(require("./Unlock"));

exports.Unlock = _Unlock["default"];

var _UploadCloud = _interopRequireDefault(require("./UploadCloud"));

exports.UploadCloud = _UploadCloud["default"];

var _Upload = _interopRequireDefault(require("./Upload"));

exports.Upload = _Upload["default"];

var _User = _interopRequireDefault(require("./User"));

exports.User = _User["default"];

var _Users = _interopRequireDefault(require("./Users"));

exports.Users = _Users["default"];

var _Volume = _interopRequireDefault(require("./Volume1"));

exports.Volume1 = _Volume["default"];

var _Volume2 = _interopRequireDefault(require("./Volume2"));

exports.Volume2 = _Volume2["default"];

var _VolumeX = _interopRequireDefault(require("./VolumeX"));

exports.VolumeX = _VolumeX["default"];

var _Volume3 = _interopRequireDefault(require("./Volume"));

exports.Volume = _Volume3["default"];

var _Wallet = _interopRequireDefault(require("./Wallet"));

exports.Wallet = _Wallet["default"];

var _XCircle = _interopRequireDefault(require("./XCircle"));

exports.XCircle = _XCircle["default"];

var _XSquare = _interopRequireDefault(require("./XSquare"));

exports.XSquare = _XSquare["default"];

var _X = _interopRequireDefault(require("./X"));

exports.X = _X["default"];

var _Zap = _interopRequireDefault(require("./Zap"));

exports.Zap = _Zap["default"];

var _ZoomIn = _interopRequireDefault(require("./ZoomIn"));

exports.ZoomIn = _ZoomIn["default"];

var _ZoomOut = _interopRequireDefault(require("./ZoomOut"));

exports.ZoomOut = _ZoomOut["default"];

var _Monitor = _interopRequireDefault(require("./Monitor"));

exports.Monitor = _Monitor["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }